export default __webpack_public_path__ + "static/media/icon2.11f49ff9.png";